import styled from "styled-components";

const IconButton = ({ icon, isActive, ...props }) => {
  return (
    <Wrapper $isActive={isActive} {...props}>
      {icon}
    </Wrapper>
  );
};

export default IconButton;

const hoverStyles = `
  background: ${(p) => p.theme.colors.blues[0]};
  color: ${(p) => p.theme.colors.primaryBlue};
`;
const Wrapper = styled.div`
  border-radius: 50%;
  display: flex;
  cursor: pointer;
  padding: 8px;
  transition: color 0.25s, background-color 0.45s;
  ${(p) => p.$isActive && hoverStyles};
  &:hover {
    ${hoverStyles}
  }
`;
